import { useForceUnauth } from "@/store/auth";
import { useMsal } from "@azure/msal-react";
import { Button, CircularProgress, Typography, styled } from "@mui/material";

const Body = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: 60px;
  height: 100vh;
  padding: 30px;
  margin: auto;
  max-width: 600px;
`;
const TitleContainer = styled("div")`
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 152px;
`;

export const SignIn = () => {
  useForceUnauth();
  const { instance } = useMsal();

  const handleSubmit = async () => {
    try {
      const result = await instance.loginRedirect({
        scopes: ["User.Read"],
      });
      console.log(result);
    } catch (error) {
      console.error(error);
    }
  };
  const loading = false;
  return (
    <Body>
      <TitleContainer>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Bienvenid@
        </Typography>
      </TitleContainer>
      <Button
        onClick={handleSubmit}
        variant="contained"
        sx={{
          height: 56,
          background: "#1E232C",
          borderRadius: 2,
          color: "white",
          "&:hover": {
            background: "#2d2626",
          },
        }}
      >
        {loading ? (
          <>
            Enviando
            <CircularProgress
              size={20}
              sx={{ marginLeft: 1, color: "white" }}
            />
          </>
        ) : (
          "Ingresar"
        )}
      </Button>
    </Body>
  );
};
